var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "sidebar-user-menu",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.closeAndFocusTrigger.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "button",
        {
          ref: "trigger",
          staticClass: "sidebar-user-menu__trigger",
          class: { "is-open": _vm.isOpen },
          attrs: {
            type: "button",
            title: _vm.collapsed ? _vm.name : null,
            "aria-expanded": _vm.isOpen ? "true" : "false",
            "aria-controls": _vm.isOpen ? _vm.panelId : null,
          },
          on: { click: _vm.toggle },
        },
        [
          _c("user-avatar", {
            attrs: { name: _vm.name, "aria-hidden": "true" },
          }),
          _c("span", { staticClass: "sidebar-user-menu__identity" }, [
            _c("span", { staticClass: "sidebar-user-menu__first-name" }, [
              _vm._v(_vm._s(_vm.firstName)),
            ]),
            _c("span", { staticClass: "sidebar-user-menu__profile" }, [
              _vm._v(_vm._s(_vm.profileLabel)),
            ]),
          ]),
          _c("lucide-icon", {
            staticClass: "sidebar-user-menu__chevron",
            attrs: {
              icon: _vm.icons.chevronUp,
              size: 16,
              "aria-hidden": "true",
            },
          }),
        ],
        1
      ),
      _c("transition", { attrs: { name: "sidebar-user-menu-panel" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "sidebar-user-menu__panel",
                style: _vm.panelStyle,
                attrs: {
                  id: _vm.panelId,
                  role: "region",
                  "aria-label": _vm.$t("menuusuario"),
                },
              },
              [
                _c("div", { staticClass: "sidebar-user-menu__header" }, [
                  _c("p", { staticClass: "sidebar-user-menu__name" }, [
                    _vm._v(_vm._s(_vm.name)),
                  ]),
                  _c(
                    "p",
                    { staticClass: "sidebar-user-menu__header-profile" },
                    [_vm._v(_vm._s(_vm.profileLabel))]
                  ),
                ]),
                _c("div", { staticClass: "sidebar-user-menu__actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "sidebar-user-menu__option",
                      attrs: { type: "button" },
                      on: { click: _vm.openLanguageModal },
                    },
                    [
                      _c("lucide-icon", {
                        staticClass: "sidebar-user-menu__option-icon",
                        attrs: {
                          icon: _vm.icons.globe,
                          size: 18,
                          "aria-hidden": "true",
                        },
                      }),
                      _c(
                        "span",
                        { staticClass: "sidebar-user-menu__option-label" },
                        [_vm._v(_vm._s(_vm.$t("idioma")))]
                      ),
                      _c(
                        "span",
                        { staticClass: "sidebar-user-menu__option-value" },
                        [_vm._v(_vm._s(_vm.currentLocale))]
                      ),
                      _c("lucide-icon", {
                        staticClass: "sidebar-user-menu__option-chevron",
                        attrs: {
                          icon: _vm.icons.chevronRight,
                          size: 16,
                          "aria-hidden": "true",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass:
                        "dm-button dm-button--danger dm-button--block",
                      attrs: { type: "button" },
                      on: { click: _vm.handleLogout },
                    },
                    [
                      _c("lucide-icon", {
                        attrs: {
                          icon: _vm.icons.logOut,
                          size: 16,
                          "aria-hidden": "true",
                        },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("sair")) + " "),
                    ],
                    1
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _c("language-settings-modal", {
        attrs: {
          open: _vm.isLanguageModalOpen,
          "current-locale": _vm.currentLocale,
          options: _vm.availableLocales,
        },
        on: {
          "update:open": function ($event) {
            _vm.isLanguageModalOpen = $event
          },
          confirm: _vm.changeLocale,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }